// eslint-disable-next-line

import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";

import { Grid, Checkbox, ListItemText, FormControlLabel, ButtonGroup } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TuneIcon from '@mui/icons-material/Tune';
import Radio from '@mui/material/Radio';

import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import { makeStyles } from '@material-ui/core/styles';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import WwDatePicker from "../../Components/Modal/WwDatePicker";
import { grey } from '@mui/material/colors';
import Slide from '@mui/material/Slide';
import { findIndex, map } from 'lodash';

import { joinByKeys } from "../../Js/Common";
import { getByMonth, currentMonth } from "../../Js/TimeAndDate";
import { getRolesBySiteUuid, getUsersByRoleId } from "../../Layouts/Users/Services";

const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


const FilterModal = (props) => {
  // Redux state
  const containerRef = useRef();
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const classes = useStyles();

  const [modalVisible, setModalVisible] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(true);
  const [isResetAll, setIsResetAll] = useState(false);

  const [month, setMonth] = useState(null);
  const [monthName, setMonthName] = useState('');

  const [commences, setCommences] = useState(null);
  const [expiries, setExpiries] = useState(null);

  const [endMinDate, setEndMinDate] = useState(Date.now());
  const [errorStartDate, setErrorStartDate] = useState(null);
  const [errorEndDate, setErrorEndDate] = useState(null);

  const [selectedRadioValue, setSelectedRadioValue] = useState('month');

  useEffect(() => {
    const initialRender = async () => {
      if (userInfo.rolesInfo.title.toLowerCase() !== 'trainer' && props.isAllTrainer) {
        let resTrainer = await getTrainerRole();
        if (resTrainer) {
          let params = {
            query: {
              $select: ['uid', 'name'],
              role_uid: resTrainer.uid,
              site_uuid: userInfo.site_uuid,
              status: true,
              $limit: -1
            }
          }
          let resUsersData = await getUsersByRoleId(params);
          if (resUsersData.data.length > 0) {
            let trainerInfo = [];
            resUsersData.data.map((userData) => {
              delete (userData.rolesInfo);
              let newUserData = {};
              newUserData.value = joinByKeys(userData.name, ['firstname', 'lastname'], ' ');
              newUserData.id = userData.uid;
              return trainerInfo.push(newUserData)
            });
            setTrainers(trainerInfo);
          }
        }
      }
      return;
    }
    initialRender();
  }, [modalVisible, userInfo]);

  useEffect(() => {
    setIsResetAll(false);

    let currentDate = new Date();
    setMonth(currentDate.getMonth());
    setMonthName(monthArr[currentDate.getMonth()]);

    let objCurrentMonth = currentMonth('YYYY-MM-DD');
    setCommences(objCurrentMonth.startOfMonth);
    setExpiries(objCurrentMonth.endOfMonth);

    //Trainer Report to default all trainer selected
    if (props.defaultSelectedValues) {
      let selectedData = [];
      if (props.defaultSelectedValues.length) {
        props.defaultSelectedValues.forEach((element, index) => {
          let objResult = trainers.find(o => o.id === element);
          selectedData.push(objResult);
        });
        setSelectedTrainers(selectedData);
        setIsCheckAll(true);
      }
    }
  }, [trainers, isResetAll]);

  const handleOpen = () => setModalVisible(true);
  const handleClose = () => setModalVisible(false);

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ['uid', 'title'],
        title: 'Trainer',
        site_uuid: userInfo.site_uuid
      }
    }
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  const handleFilter = () => {
    let trainerUuids = [];
    // console.log("userInfo=====>",userInfo);

    if(userInfo.rolesInfo.title.toLowerCase() === 'trainer') {
      trainerUuids.push(userInfo.uid);
    } else {
      trainerUuids = selectedTrainers.map(value => value.id);
    }
    
    if (selectedRadioValue === 'month') {
      let objCurrentMonth = getByMonth(month, 'YYYY-MM-DD');
      let startDt = objCurrentMonth.startOfMonth;
      let endDt = objCurrentMonth.endOfMonth;
      props.press({
        "selectedTrainers": trainerUuids,
        "start_date": startDt,
        "end_date": endDt
      });
    } else {
      props.press({
        "selectedTrainers": trainerUuids,
        "start_date": commences,
        "end_date": expiries
      });
    }
    handleClose();
  };

  const handleRadioChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };

  // Select All trainers
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setSelectedTrainers(trainers.map(itemData => itemData));
    if (isCheckAll) {
      setSelectedTrainers([]);
    }
  };

  // Add & Remove trainer from selection
  const handleSelectSingle = (itemData) => {
    let newArray = [...selectedTrainers];
    let fndIndx = findIndex(selectedTrainers, { id: itemData.id });
    if (fndIndx === -1) {
      newArray.push(itemData);
    } else {
      newArray.splice(fndIndx, 1);
    }
    setSelectedTrainers(newArray);
    if (newArray.length === trainers.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  // Date change
  const DateChange = (date, valid, err, field) => {
    if (valid) {
      if (field === "startdate") {
        let endMinTime = new Date(date);
        setCommences(date);
        setEndMinDate(endMinTime.getTime());
        setErrorStartDate(null);
      }
      if (field === "enddate") {
        setExpiries(date);
        setErrorEndDate(null);
      }
    } else {
      setTimeout(() => {
        if (field === "startdate") {
          setCommences(null);
          setErrorStartDate(err);
        }
        if (field === "enddate") {
          setExpiries(null);
          setErrorEndDate(err);
        }
      }, 500);
    }
  };

  const getPrevMonth = () => {
    if (month === 0) return;
    let selMon = month - 1;
    setMonth(selMon);
    setMonthName(monthArr[selMon]);
  };

  const getNextMonth = () => {
    let currentDate = new Date();
    if (month >= currentDate.getMonth() || month === 11) return;
    let selMon = month + 1;
    setMonth(selMon);
    setMonthName(monthArr[selMon]);
  };

  const resetState = () => {
    setSelectedTrainers([]);
    setCommences(null);
    setExpiries(null);
    setIsCheckAll(false);
    setErrorStartDate(null);
    setErrorEndDate(null);
    setSelectedRadioValue('month');
    setIsResetAll(true);
  }

  return (
    <div>
      <Button 
        variant="contained" 
        onClick={handleOpen} 
        endIcon={<TuneIcon />} 
        sx={{ borderRadius: 10, fontWeight: "600", backgroundColor: '#2bff2bff', color: "#5f5600ff", boxShadow: 0, textTransform: 'inherit', '&:hover': { backgroundColor: '##5f5600ff', color: '#2bff2bff' }, '@media (min-width: 1636px)': {
          fontSize: '1.4rem'
        } }}>
        Filter
      </Button>
      <Modal
        open={modalVisible}
        onClose={handleClose}
        ref={containerRef}
        sx={{ border: "0px !important" ,display: 'flex', justifyContent: 'center', alignItems: 'center'}}
      >
        <Slide direction="up" in={modalVisible} container={containerRef.current}>
        <Box className={classes.Modal}>
          {trainers && userInfo && userInfo.rolesInfo.title.toLowerCase() !== 'trainer' && props.isAllTrainer && (
            <Grid container>
              <FormControlLabel
                sx={{ ml: '0.2rem' }}
                size="small"
                control={
                  <Checkbox
                    checked={isCheckAll}
                    onChange={handleSelectAll}
                    sx={{
                      color: grey[200],
                      '&.Mui-checked': {
                        color: grey[200],
                      },
                    }}
                  />
                }
                label={<Typography color="#5f5600ff" sx={{
                  fontSize: '0.9rem', fontWeight: '500', '@media (min-width: 1636px)': {
                      fontSize: '1.4rem', my: 1
                  }
              }}>All Trainer</Typography>}
              />
              <FormControl fullWidth sx={{ mx: 1, mb: 1 }}>
                <Select
                  displayEmpty
                  multiple
                  value={selectedTrainers}
                  placeholder="Select Trainer"
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    borderRadius: 5,
                    backgroundColor: "#2bff2bff",
                  }}
                  renderValue={(selected) => {
                    return (
                      map(selected, "value").join(", ")
                    );
                  }}
                >
                  {trainers.map((itemData, index) => (
                    <MenuItem key={`${index}_Trainer`} value={itemData} onClick={() => handleSelectSingle(itemData)}>
                      <Checkbox
                        checked={selectedTrainers.filter((item) => item.id === itemData.id).length > 0}
                      />
                      <ListItemText primary={itemData.value} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Grid>
          )}
          <Grid container style={{ gap: 1, justifyContent: 'space-between' }}>
            <Grid item xs={3} ml={1}>
              <FormControlLabel
                control={
                  <Radio
                    checked={selectedRadioValue === 'month'}
                    value='month'
                    onChange={handleRadioChange}
                    sx={{
                      color: grey[50],
                      '&.Mui-checked': {
                        color: grey[50],
                      }
                    }}
                  />
                }
                label={<Typography color="#5f5600ff" sx={{
                  fontSize: '0.9rem', fontWeight: '500', '@media (min-width: 1636px)': {
                      fontSize: '1.4rem', my: 1
                  }
              }}>Month</Typography>}
                sx={{ color: "#5f5600ff" }}
              />
            </Grid>
            <Grid item xs={5}>
              <ButtonGroup
                disableElevation
              >
                <IconButton onClick={getPrevMonth}>
                  <KeyboardDoubleArrowLeftIcon sx={{ fontSize: '2rem', color: '#5f5600ff','@media (min-width: 1636px)': {
                      fontSize: '2.4rem'
                  } }} />
                </IconButton>
                <Typography sx={{ fontSize: '1rem',fontWeight: '600',pt: 1, borderRight: 0, color: '#5f5600ff','@media (min-width: 1636px)': {
                      fontSize: '1.4rem'
                  }  }}>{monthName}</Typography>
                <IconButton onClick={getNextMonth}>
                  <KeyboardDoubleArrowRightIcon sx={{ fontSize: '2rem', color: '#5f5600ff','@media (min-width: 1636px)': {
                      fontSize: '2.4rem'
                  }  }} />
                </IconButton>
              </ButtonGroup>
            </Grid>
          </Grid>
          <Grid item xs={3} ml={1}>
            <FormControlLabel
              control={
                <Radio
                  checked={selectedRadioValue === 'range'}
                  value='range'
                  onChange={handleRadioChange}
                  sx={{
                    color: grey[50],
                    '&.Mui-checked': {
                      color: grey[50],
                    }
                  }}
                />
              }
              label={<Typography color="#5f5600ff" sx={{
                fontSize: '0.9rem', fontWeight: '500', '@media (min-width: 1636px)': {
                    fontSize: '1.4rem', my: 1
                }
            }}>Range</Typography>}
              sx={{ color: "#5f5600ff" }}
            />
          </Grid>
          <Grid container sx={{}}>
            <Grid item xs={6} sx={{ px: 1 }}>
              <WwDatePicker
                dateChange={({ date, valid, errorMessage }) =>
                  DateChange(date, valid, errorMessage, "startdate")
                }
                maxDate={Date.now()}
                defaultDate={commences}
              ></WwDatePicker>
            </Grid>
            <Grid item xs={6} sx={{ px: 1 }}>
              <WwDatePicker
                dateChange={({ date, valid, errorMessage }) =>
                  DateChange(date, valid, errorMessage, "enddate")
                }
                minDate={endMinDate}
                defaultDate={expiries}
              ></WwDatePicker>
            </Grid>
            {errorStartDate &&
              <Grid>
                <Typography className={classes.errorMessage}>{errorStartDate}</Typography>
              </Grid>
            }
            {errorEndDate &&
              <Grid>
                <Typography className={classes.errorMessage}>{errorEndDate}</Typography>
              </Grid>
            }
          </Grid>
          <Box sx={{ my: 3, mx: 4 }}>
            <Button
              variant="standard"
              fullWidth
              sx={{
                color: "#5f5600ff",
                fontSize: "1.2rem",
                fontWeight: "700",
                border: 1,
                borderColor: "#5f5600ff",
                borderRadius: 10,
               
              }}
              onClick={handleFilter}
            >
              Apply
            </Button>
          </Box>
          <Box sx={{ mx: 4 }}>
            <Button
              variant="standard"
              fullWidth
              sx={{
                color: "#5f5600ff",
                fontSize: "1.2rem",
                fontWeight: "700",
                border: 1,
                borderColor: "#5f5600ff",
                borderRadius: 10,
                
              }}
              onClick={resetState}
            >
              Reset
            </Button>
          </Box>
        </Box>
        </Slide>
      </Modal>
    </div>
  );
}
const useStyles = makeStyles({
  Modal: {
    width: 400,
    background:'linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)',
    boxShadow: 24,
    color: '#5f5600ff',
    borderRadius: 30,
    padding: 20,
  },
  errorMessage: {
    backgroundColor: 'red',
    color: '#5f5600ff',
    borderRadius: 30,
    padding: '10px 20px',
  },
})
export default FilterModal;